<template>
    <!-- <appPage :back-img="info?.background" class="detail-page" :isDefaultBackground="true"
        @click="showPreviewName = false; showLevelTip = false"> -->
    <div class="detail-page" @scroll="handleScroll">
        <div class="h-450px absolute top-0 left-0 w-100%">
            <img :src="info?.background" alt="" class="w-100% h-100% object-cover">
        </div>
        <!-- 滚动遮罩层 -->
        <div class="scroll-overlay" :style="{ opacity: overlayOpacity }"></div>
        <!-- 顶部导航 -->
        <div class="header flex items-center justify-between p-20px pt-42px! fixed top-0 left-0 w-100vw z-1112"
            :style="{ backgroundColor: headerOpacity ? '#01031b' : 'transparent' }">
            <div class="flex items-center">
                <div class="w-28px h-28px cursor-pointer" @click="handleBack">
                    <img src="@/assets/images/mine/left.webp" alt="" class="w-full h-full" />
                </div>
            </div>

            <van-popover v-model:show="showPopover" placement="bottom-end" actions-direction="vertical">
                <van-grid clickable :border="false" column-num="1" style="width: 180px;">
                    <div v-for="i in popoverList" :key="i.name" class="w-100% flex items-center p-10px"
                        @click="handlePopover(i.name)">
                        <img :src="i.icon" alt="" class="w-20px" />
                        <div class="ml-5px color-#01031B font-500 text-12px opacity-50 mt-2px">
                            {{ i.name }}
                        </div>
                    </div>
                </van-grid>

                <template #reference>
                    <div class="w-28px h-28px">
                        <img src="@/assets/images/chat/detail/more.svg" alt="" class="w-full h-full" />
                    </div>
                </template>
            </van-popover>
        </div>
        <!-- 等级 -->
        <div class="level-wrapper absolute top-0 right-15px! z-1000" @click.stop="handleToggleLevelTip">
            <!-- 心形图标行 -->
            <!-- 进度条和等级文字 -->
            <div class="level-content">
                <div class="progress-bar">
                    <div class="progress-fill" :style="{ height: `${progressPercent?.progress || 0}%` }"></div>
                </div>
                <div class="absolute top-20px right-10px">
                    <div class="h-52px relative">
                        <div class="w-20px h-20px" v-if="progressPercent?.type >= 1">
                            <img src="@/assets/images/chat/detail/heart.webp" alt="" class="w-full h-full">
                        </div>

                        <div class="w-20px h-20px" v-else>
                            <img src="@/assets/images/chat/detail/heart_no.webp" alt="" class="w-full h-full">
                        </div>
                        <div class="text-10px absolute top-25% left-50% transform -translate-x-1/2 -translate-y-1/2">1
                        </div>
                    </div>
                    <div class="h-52px relative">
                        <div class="w-20px h-20px" v-if="progressPercent?.type >= 2">
                            <img src="@/assets/images/chat/detail/heart.webp" alt="" class="w-full h-full">
                        </div>
                        <div class="w-20px h-20px" v-else>
                            <img src="@/assets/images/chat/detail/heart_no.webp" alt="" class="w-full h-full">
                        </div>
                        <div class="text-10px absolute top-25% left-50% transform -translate-x-1/2 -translate-y-1/2">2
                        </div>

                    </div>
                    <div class="h-52px relative">
                        <div class="w-20px h-20px" v-if="progressPercent?.type >= 3">
                            <img src="@/assets/images/chat/detail/heart.webp" alt="" class="w-full h-full">
                        </div>
                        <div class="w-20px h-20px" v-else>
                            <img src="@/assets/images/chat/detail/heart_no.webp" alt="" class="w-full h-full">
                        </div>
                        <div class="text-10px absolute top-25% left-50% transform -translate-x-1/2 -translate-y-1/2">3
                        </div>

                    </div>
                    <div class="h-52px relative">
                        <div class="w-20px h-20px" v-if="progressPercent?.type >= 4">
                            <img src="@/assets/images/chat/detail/heart.webp" alt="" class="w-full h-full">
                        </div>
                        <div class="w-20px h-20px" v-else>
                            <img src="@/assets/images/chat/detail/heart_no.webp" alt="" class="w-full h-full">
                        </div>
                        <div class="text-10px absolute top-25% left-50% transform -translate-x-1/2 -translate-y-1/2">4
                        </div>

                    </div>
                    <div class="h-52px relative">
                        <div class="w-20px h-20px" v-if="progressPercent?.type >= 5">
                            <img src="@/assets/images/chat/detail/heart.webp" alt="" class="w-full h-full">
                        </div>
                        <div class="w-20px h-20px" v-else>
                            <img src="@/assets/images/chat/detail/heart_no.webp" alt="" class="w-full h-full">
                        </div>
                        <div class="text-10px absolute top-25% left-50% transform -translate-x-1/2 -translate-y-1/2">5
                        </div>

                    </div>
                </div>
            </div>
            <!-- 等级详情弹窗 -->
            <div v-if="showLevelTip"
                class="level-tip-popup absolute top-50px left--250% transform -translate-x-1/2 color-#000 bg-#fff p-10px z-1000 rounded-10px">
                <div class="text-12px"> {{ t('messageDetail.increaseFavorability') }} </div>
                <div class="text-12px"> {{ t('messageDetail.levelFormat', { level: 1 }) }} ({{ info?.expLevel1 }} {{
                    t('messageDetail.messageCount', { count: info?.expLevel1 }) }}) </div>
                <div class="text-12px"> {{ t('messageDetail.levelFormat', { level: 2 }) }} ({{ info?.expLevel2 }} {{
                    t('messageDetail.messageCount', { count: info?.expLevel2 }) }}) </div>
                <div class="text-12px"> {{ t('messageDetail.levelFormat', { level: 3 }) }} ({{ info?.expLevel3 }} {{
                    t('messageDetail.messageCount', { count: info?.expLevel3 }) }}) </div>
                <div class="text-12px"> {{ t('messageDetail.levelFormat', { level: 4 }) }} ({{ info?.expLevel4 }} {{
                    t('messageDetail.messageCount', { count: info?.expLevel4 }) }}) </div>
                <div class="text-12px"> {{ t('messageDetail.levelFormat', { level: 5 }) }} ({{ info?.expLevel5 }} {{
                    t('messageDetail.messageCount', { count: info?.expLevel5 }) }}) </div>
            </div>
        </div>

        <!-- 顶部背景占位 -->
        <div class="banner-space"></div>

        <!-- 内容区域 -->
        <div class="detail-content relative">
            <!-- 头像 -->

            <!-- 用户信息 -->
            <div class="flex items-center info justify-between absolute top--115px left-0 pt-50px! w-100% z-1111">
                <div class="color-#fff relative">
                    <div @click.stop="handlePreviewName" class="text-20px font-900 ">
                        {{ info?.name }}
                    </div>

                    <div v-if="showPreviewName" class="preview-name">
                        {{ info?.name }}
                    </div>

                    <div class="text-14px flex items-center color-#FFFFFF66">
                        ID:{{ info?.id }}
                        <img src="@/assets/images/chat/detail/chat_num.svg" class="w-12px h-12px ml-5px" />
                        <div class="text-9px ml-2px color-#fff">
                            {{ info?.chatCount > 1000 ? (((info?.chatCount)) / 1000).toFixed(2) + 'k' : '' }}
                        </div>
                    </div>
                </div>

                <!-- 点赞 -->
                <div class="w-30px h-30px ml-4px cursor-pointer mt-4px flex-shrink-0" @click="handleLike"
                    :class="{ heartbeat: isLiking }">
                    <img v-if="info?.isFavorite" src="@/assets/images/message/like.webp" class="w-full h-full" />

                    <img v-else src="@/assets/images/message/like_no.webp" class="w-full h-full" />
                </div>
            </div>


            <!-- 相册 -->
            <div class="mt-20px">
                <div class="flex items-center justify-between">
                    <div class="color-#fff text-16px font-900">
                        {{ t('messageDetail.album') }}
                    </div>
                    <div class="text-12px color-#FFFFFF66" @click="goToBackground(backgroundStore.backgroundList)">
                        See all
                    </div>
                </div>

                <!-- 加载中骨架屏 -->

                <!-- 相册列表 -->
                <div v-if="backgroundStore.backgroundList.length > 0" class="album-list">
                    <div v-for="(item, index) in backgroundStore.backgroundList.slice(0, 3)" :key="item.id"
                        class="album-item" @click="handlePreviewAlbum(item.url, item.typeSee, item, index)">
                        <AppImage :src="item.url" alt="avatar" width="100%" height="100%" :show-loading="true"
                            :show-error="true" :lazy-load="false" :custom-loading="true" :custom-error="true"
                            fallback="@/assets/images/home/sitemap.webp" fit="cover"
                            @error="() => console.log('Image error:', item.url)" />

                        <div v-if="!item.isUnlock" class="locked-overlay">
                            <img src="@/assets/images/other/lock.svg" class="lock-icon" />
                        </div>
                    </div>
                </div>
                <div v-else class="album-list">
                    <div v-for="i in 3" :key="i" class="album-item skeleton-item">
                        <div class="skeleton-loading"></div>
                    </div>
                </div>
            </div>

            <!-- 简介 -->
            <div class="mt-20px">
                <div class="color-#fff text-16px font-900 relative">
                    {{ t('messageDetail.intro') }}
                </div>
                <div class="text-info relative" :class="{ 'line-clamp-4': !isNotesExpanded }"
                    @click="isNotesExpanded = !isNotesExpanded">
                    {{ info?.creatorNotes || t('messageDetail.noIntro') }}
                    <div v-if="info?.creatorNotes" class="expand-btn absolute right-0 bottom-5px">
                        <img src="@/assets/images/chat/detail/down.svg" alt="" class="w-10px h-10px"
                            :class="{ 'rotate-180': isNotesExpanded }" />
                    </div>
                </div>
            </div>

            <!-- 标签 -->
            <div v-if="info?.tags || info?.roleInfo?.tags" class="mt-20px">
                <div class="color-#fff text-12px font-900">
                    {{ t('messageDetail.tags') }}
                </div>

                <div class="flex flex-wrap mt-10px">
                    <div v-for="item in info?.tags || info?.roleInfo?.tags" :key="item" class="text-info-item">
                        {{ item }}
                    </div>
                </div>
            </div>

            <div v-if="recommendRoles.length > 0">
                <div class="color-#fff text-12px font-900 mb-10px">
                    Recommend
                </div>
                <div class="flex flex-wrap gap-10px">
                    <div class="w-48%" v-for="value in recommendRoles" @click="goToCaht(value)">
                        <div class="w-165px h-232px rounded-10px overflow-hidden">
                            <img :src="value.background" alt="" class="w-full h-full object-cover">
                        </div>
                        <div class="text-12px color-#FFFFFF66 mt-10px text-ellipsis-3">
                            {{ value.creatorNotes }}
                        </div>
                    </div>
                </div>
            </div>

            <AppOccupySpace height="120px" />

            <!-- 回到顶部按钮 -->
            <Transition name="fade">
                <div v-if="showBackToTop" class="back-to-top" @click="scrollToTop">
                    <img src="@/assets/images/home/up.webp" alt="" class="w-40px h-40px" />
                </div>
            </Transition>
        </div>

        <!-- 底部按钮 -->
        <div class="bottom-btn" @click="router.back()">
            {{ t('messageDetail.backToChat') }}
        </div>
        <van-popup v-model:show="showPopup" position="bottom" round class="p-20px">
            <Report :recordId="''" :reportType="reportType" :close="handleClosePopup" :info="info" />
        </van-popup>
        <!-- 全屏图片预览 -->
        <FullscreenImagePreview v-model:show="showImagePreview" :images="previewImages" :infoItem="infoItem"
            :start-position="previewStartPosition" @close="handleCloseImagePreview"
            :isShowSetAsBackdrop="isShowSetAsBackdrop" @check-bg="handleSetBackGround"
            @unlockSuccess="handleUnlockSuccess" :isShowbackDrop="isShowbackDrop"
            :numberChatMessages="numberChatMessages" :numberChatMessagesTotal="info?.levelExpOrigin" />
    </div>
</template>

<script setup lang="ts">
import { calculateLevelProgress } from './index.ts'
import AppImage from '@/components/display/AppImage.vue'
import { AppOccupySpace } from '@/components/layout'
import { useRouter, useRoute } from 'vue-router'
import { onMounted, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { useDialog } from '@/composables/useDialog'
import reportIcon from '@/assets/images/message/report.svg'
import { MessageAPI } from '@/services/message'
import { FullscreenImagePreview } from '@/components/feedback'
import { showFailToast, showLoadingToast, showSuccessToast } from 'vant'
import { useUserStore } from '@/stores/user'
import Report from './Component/ChatReport.vue'
import { computed } from 'vue'
import { useBackgroundStore } from '@/stores/background'
import { detailDB } from '@/utils/detailDB'
import { HomeAPI } from '@/services/home'
const router = useRouter()
const { t } = useI18n()
const dialog = useDialog()
// 路由
const route = useRoute()
// 角色详情
const info = ref<any>(null)
// 用户存储
const userStore = useUserStore()
// 聊天费用
const expenses = computed(() => userStore.getChatExpenses())
// 等级进度
const expList = ref()
// 进度百分比
const progressPercent = ref()
// 背景存储
const backgroundStore = useBackgroundStore()
// 弹出框
const showPopover = ref(false)
const showPopup = ref(false)
// 举报类型
const reportType = ref<any[]>([])
// 预览名字
const showPreviewName = ref(false)
// 等级提示
const showLevelTip = ref(false)
// 设置背景
const isShowSetAsBackdrop = ref(false)
// 是否显示背景遮罩
const isShowbackDrop = ref(false)
// 全屏预览状态
const showImagePreview = ref(false)
// 预览图片
const previewImages = ref<string[]>([])
// 预览起始位置
const previewStartPosition = ref(0)
// 预览信息
const infoItem = ref<any>(null)
// 聊天消息数量
const numberChatMessages = ref<number | undefined>(0)
// 点赞动画状态
const isLiking = ref(false)
const isShowFree = computed(() => userStore.getIsFree().includes(info.value?.pid))
const isNotesExpanded = ref(false)
// 滚动遮罩透明度
const overlayOpacity = ref(0)
// 最大滚动距离（遮罩完全变黑的距离）
const maxScrollDistance = 300
// 头部透明度
const headerOpacity = ref()
// 回到顶部按钮
const showBackToTop = ref(false)
// 推荐角色
const recommendRoles = ref<any[]>([])
// 滚动处理
const handleScroll = (e: Event) => {
    const target = e.target as HTMLElement
    const scrollTop = target.scrollTop || window.scrollY

    // 根据滚动距离计算透明度，滚动越远越黑
    const opacity = Math.min(scrollTop / maxScrollDistance, 1)
    if (scrollTop > 300) {
        headerOpacity.value = true
    } else {
        headerOpacity.value = false
    }

    overlayOpacity.value = opacity

    // 显示/隐藏回到顶部按钮
    showBackToTop.value = scrollTop > 500
}

// 回到顶部
const scrollToTop = () => {
    const container = document.querySelector('.detail-page') as HTMLElement
    if (container) {
        container.scrollTo({ top: 0, behavior: 'smooth' })
    }
}

const goToBackground = (list: any[]) => {
    router.push({
        path: '/background',
        query: {
            list: encodeURIComponent(JSON.stringify(list)),
            id: info.value.id,
            levelExpOrigin: info.value.levelExpOrigin
        }
    })
}

const popoverList = ref([
    {
        name: 'Report',
        icon: reportIcon,
    },
])


/**
 * 返回
 */
const handleBack = () => {
    const preData = {
        name: info.value?.name,
        avatar: info.value?.avatar,
        background: info.value?.backgroundThumb || info.value?.roleInfo?.backgroundThumb,
        id: info.value?.id,
        creatorNotes: info.value?.creatorNotes,
    }
    router.push({
        path: '/chat',
        query: {
            preData: encodeURIComponent(JSON.stringify(preData)),
            route: route.query.route as string
        }
    })
}

const goToCaht = (value: any) => {
    router.push({
        path: '/chat',
        query: {
            preData: encodeURIComponent(JSON.stringify(value)),
            route: route.query.route as string
        }
    })
}

/**
 * 预览名字
 */
const handlePreviewName = () => {
    showPreviewName.value = !showPreviewName.value
}

/**
 * 切换等级提示显示状态
 */
const handleToggleLevelTip = () => {
    showLevelTip.value = !showLevelTip.value
}
/**
 * 点赞
 */
const handleLike = async () => {
    // 触发心跳动画
    isLiking.value = true

    // 动画持续时间
    setTimeout(() => {
        isLiking.value = false
    }, 600)

    if (info.value?.roleInfo) {
        info.value.roleInfo.isFavorite = !info.value?.roleInfo.isFavorite
    } else {
        info.value.isFavorite = !info.value?.isFavorite
    }
    await detailDB.save(info.value?.id, info.value)
    try {
        await MessageAPI.favoriteRole({
            roleId: info.value?.id,
        })
    } catch (error) {
        showFailToast('Collection failed')
    }
}

/**
 * 弹出框
 */
const handlePopover = (name: string) => {
    if (name === 'Report') {
        showPopup.value = true
    } else if (name === 'Edit Profile') {
        router.push({ name: 'EditProfile' })
    } else if (name === 'Delete Message') {
    }
}

/**
 * 获取举报类型
 */
const getReportType = async () => {
    const res = await MessageAPI.reportType()
    reportType.value = res.data
}

/**
 * 关闭弹窗
 */
const handleClosePopup = () => {
    showPopup.value = false
}

/**
 * 预览头像
 */
const handlePreviewAvatar = () => {
    if (!info.value?.avatar) {
        return
    }

    previewImages.value = [info.value?.avatar]
    previewStartPosition.value = 0
    showImagePreview.value = true
    isShowbackDrop.value = false
    isShowSetAsBackdrop.value = false
}

/**
 * 预览专辑
 */
const handlePreviewAlbum = (url?: string, typeSee?: number, item?: any, index?: number) => {
    isShowSetAsBackdrop.value = !item.isUnlock
    infoItem.value = item
    numberChatMessages.value = index
    // 构建图片数组，可以包含多张图片
    const images = []

    // 添加背景图片
    if (url) {
        images.push(url)
    }

    // 如果没有图片，显示提示
    if (images.length === 0) {
        console.warn('没有可预览的图片')
        return
    }

    previewImages.value = images
    previewStartPosition.value = 0
    showImagePreview.value = true
    isShowbackDrop.value = true
}

/**
 * 预览背景专辑
 */
const handlePreviewBackgroundAlbum = (url?: string) => {
    if (!url) {
        console.warn('没有可预览的背景')
        return
    }
    previewImages.value = [url]
    previewStartPosition.value = 0
    showImagePreview.value = true
    isShowbackDrop.value = false
    isShowSetAsBackdrop.value = false
}

/**
 * 关闭图片预览
 */
const handleCloseImagePreview = () => {
    showImagePreview.value = false
    previewImages.value = []
    previewStartPosition.value = 0
}

/**
 * 获取角色相册
 */
const getRoleAlbum = async () => {
    await backgroundStore.getBackgroundList(info.value?.id)
}

/**
 * 设置背景
 */
const handleSetBackGround = async () => {
    showLoadingToast(t('message.setting'))
    await MessageAPI.setRoleImage({
        imageId: infoItem.value.id
    }).then(() => {
        detailDB.update(info.value?.id, info.value)

        if (info.value?.background) {
            info.value.background = infoItem.value.url
        } else if (info.value?.roleInfo) {
            info.value.roleInfo.background = infoItem.value.url
        } else {
            // 如果都没有，创建一个 roleInfo 对象
            info.value.roleInfo = { background: infoItem.value.url }
        }
        showSuccessToast('Successful switch')


        const preData = {
            name: info.value?.name,
            avatar: info.value?.avatar,
            background: info.value?.background || info.value?.roleInfo?.background,
            id: info.value?.id,
            creatorNotes: info.value?.creatorNotes,
        }

        router.push({
            path: '/chat',
            query: { preData: encodeURIComponent(JSON.stringify(preData)), route: route.query.route as string }
        })
        showImagePreview.value = false
    }).finally(() => {
        // closeToast()

    })
}

/**
 * 处理解锁成功
*/
const handleUnlockSuccess = async (imageId: number) => {
    // 更新本地相册数据，将解锁的图片标记为已解锁
    if (backgroundStore.backgroundList) {
        const unlockedItem = backgroundStore.backgroundList.find((item: any) => item.id === imageId)
        if (unlockedItem) {
            unlockedItem.isUnlock = true
        }
    }
    // 当前预览应立即去除遮罩
    isShowSetAsBackdrop.value = false
    await backgroundStore.getBackgroundList(info.value?.id)
}
/**
 * 获取数字人详情
*/
const getRoleDetail = async (id: string) => {
    info.value = await detailDB.get(id)

    const res = await MessageAPI.getRoleDetail({
        id: Number(id),
    })
    if (res.data) {
        info.value = res.data
        expList.value = [info.value?.expLevel1, info.value?.expLevel2, info.value?.expLevel3, info.value?.expLevel4, info.value?.expLevel5]
        progressPercent.value = calculateLevelProgress(expList.value, info.value?.levelExpOrigin)
    }
}

const imgLoading = ref(false)

const handleLoad = () => {
    imgLoading.value = true
}

const getRecommendRoles = async () => {
    const res = await HomeAPI.getRecommendRoles({})
    recommendRoles.value = res.data.recommendList
}

onMounted(async () => {

    // 🚀 先读本地缓存（秒开）
    if (route.query.id) {
        info.value = await detailDB.get(route.query.id as string)
    }

    // 🚀 首屏只请求详情
    await getRoleDetail(route.query.id || info.value?.id)

    // 🚀 非首屏接口后台加载
    getReportType()
    // getRoleAlbum()
    getRecommendRoles()
    getRoleAlbum()
})
</script>

<style scoped lang="scss">
.detail-page {
    height: 100vh;
    overflow-y: auto;
    overflow-x: hidden;
    position: relative;

    img {
        object-position: center top;
    }
}

.banner-space {
    height: 450px;
    width: 100%;
    flex-shrink: 0;
}

.detail-content {
    position: relative;
    margin-top: -30px;
    // border-radius: 24px 24px 0 0;
    // background: #01031b;
    min-height: calc(100vh - 220px);
    padding: 20px;
    padding-top: 10px;

    .info {
        padding: 20px;
        background: linear-gradient(180deg, rgba(1, 3, 27, 0) 0%, #01031B 100%);
        height: 146px;
    }
}

.avatar-box {
    width: 85px;
    height: 85px;
    border-radius: 999px;
    overflow: hidden;
    position: absolute;
    top: -35px;
    left: 20px;
    background: #01031b;
    cursor: pointer;
}

.avatar-inner {
    width: 75px;
    height: 75px;
    border-radius: 999px;
    overflow: hidden;
    margin-top: 5px;
    margin-left: 5px;
}

.preview-name {
    position: absolute;
    top: -50px;
    right: 0;
    width: 200px;
    padding: 10px;
    background: #fff;
    border-radius: 10px;
    color: #333;
    font-size: 14px;
    font-weight: 500;
    word-break: break-word;
}

.album-list {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    margin-top: 10px;
}

.album-item {
    width: 105px;
    height: 158px;
    border-radius: 6px;
    overflow: hidden;
    position: relative;
}

.skeleton-item {
    background: rgba(255, 255, 255, 0.1);
}

.skeleton-loading {
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg,
            rgba(255, 255, 255, 0.05) 0%,
            rgba(255, 255, 255, 0.15) 50%,
            rgba(255, 255, 255, 0.05) 100%);
    background-size: 200% 100%;
    animation: skeleton-shimmer 1.5s ease-in-out infinite;
}

@keyframes skeleton-shimmer {
    0% {
        background-position: 200% 0;
    }

    100% {
        background-position: -200% 0;
    }
}

.locked-overlay {
    position: absolute;
    inset: 0;
    background: rgba(1, 3, 27, 0.5);
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);
}

.lock-icon {
    width: 13px;
    height: 13px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}

/* 进度条 */
.progress-bar {
    width: 4px;
    height: 260px;
    background: rgba(255, 255, 255, 0.2);
    border-radius: 10px;
    overflow: hidden;
    position: relative;
}

.progress-fill {
    height: 100%;
    border-radius: 10px;
    // background: linear-gradient(117deg, #9a4be7 0%, #e44d84 100%);
    background: linear-gradient(180deg, #FFFFFF 0%, #FF488B 100%);
    transition: width 0.3s ease;
}

/* 标签 */
.text-info-item {
    background-color: rgba(255, 255, 255, 0.1);
    padding: 2px 10px;
    font-size: 12px;
    color: #6C83AE;
    margin-right: 10px;
    margin-bottom: 10px;
    // border-radius: 999px;
    border-radius: 3px;
}

.text-info {
    color: rgba(255, 255, 255, 0.7);
    line-height: 1.7;
    font-size: 14px;
}

.text-intro {
    display: -webkit-box;
    -webkit-line-clamp: 4;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: break-word;
}

/* 底部按钮 */
.bottom-btn {
    position: fixed;
    left: 4%;
    bottom: 20px;
    width: 92%;
    height: 46px;
    border-radius: 23px;
    text-align: center;
    line-height: 46px;
    font-size: 16px;
    font-weight: 900;
    color: #fff;
    z-index: 200;

    background: linear-gradient(180deg,
            #5a68ff 0%,
            #95a5ff 100%);
}

/* 心跳动画 */
.heartbeat {
    animation: heartbeat 0.6s ease-in-out;
}

@keyframes heartbeat {
    0% {
        transform: scale(1);
    }

    14% {
        transform: scale(1.3);
    }

    28% {
        transform: scale(1);
    }

    42% {
        transform: scale(1.3);
    }

    70% {
        transform: scale(1);
    }
}

/* 滚动遮罩层 */
.scroll-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 450px;
    background: #01031b;
    pointer-events: none;
    z-index: 1;
    transition: opacity 0.1s ease;
}

/* 等级包装器 */
.level-wrapper {
    position: absolute;
    // top: 50px;
    top: 70px;

    right: 50px;
    width: 40px;
    background-color: rgba(0, 0, 0, 0.5);
    border-radius: 6px;
    margin-top: 20px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    align-items: center;
    justify-content: center;
    height: 280px;
}

/* 心形图标行 - 在进度条上方 */
.hearts-row {
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    // width: 260px;
    padding-left: 6px;
    margin-bottom: 5px;

    .heart-icon {
        width: 20px;
        height: 20px;
        object-fit: contain;
    }

    .heart-active {
        animation: heartPulse 1.5s ease-in-out infinite;
    }
}

/* 进度条和等级文字 */
.level-content {
    display: flex;
    height: 260px;
    align-items: center;
    justify-content: center;
}

.progress-bar {
    width: 4px;
    height: 260px;
    background: rgba(255, 255, 255, 0.2);
    border-radius: 10px;
    overflow: hidden;
    position: relative;
}

.progress-fill {
    width: 100%;
    background: linear-gradient(180deg, #FFFFFF 0%, #FF488B 100%);

    border-radius: 10px;
    transition: height 0.3s ease;
}

/* 右边：等级文字 */
.level-right {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
    padding-left: 10px;
}

/* 等级提示弹窗 */
.level-tip-popup {
    width: 180px;
}

/* 心跳动画 */
@keyframes heartPulse {

    0%,
    100% {
        transform: scale(1);
    }

    50% {
        transform: scale(1.15);
    }
}

/* 文字超过3行省略 */
.text-ellipsis-3 {
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: break-word;
}

/* 文字超过4行省略 */
.line-clamp-4 {
    display: -webkit-box;
    -webkit-line-clamp: 4;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: break-word;
}

/* 展开按钮 */
.expand-btn {
    // background: linear-gradient(to right, transparent, #1A1A2E 30%);
    padding-left: 20px;
    display: flex;
    align-items: flex-end;
}

/* 回到顶部按钮 */
.back-to-top {
    position: fixed;
    bottom: 100px;
    right: 20px;
    width: 40px;
    height: 40px;
    background: rgba(255, 255, 255, 0.2);
    backdrop-filter: blur(10px);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    z-index: 100;
    transition: all 0.3s ease;

    &:hover {
        background: rgba(255, 255, 255, 0.3);
        transform: scale(1.1);
    }
}

/* 渐隐动画 */
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}
</style>